import { Controller } from "@hotwired/stimulus"

// Provides smooth animation for visibility toggle switches
// Animates immediately on click for instant feedback
export default class extends Controller {
  static targets = ["track", "knob"]
  static values = { active: Boolean }

  toggle(event) {
    // Animate to the opposite state immediately
    const newState = !this.activeValue
    this.animateToggle(newState)
    this.activeValue = newState
  }

  animateToggle(active) {
    // Calculate the translation distance (track width - knob width - padding)
    const trackWidth = this.trackTarget.offsetWidth
    const knobWidth = this.knobTarget.offsetWidth
    const translateX = trackWidth - knobWidth - 4 // 4px for 2px padding on each side

    if (active) {
      // Animate to active state
      this.trackTarget.classList.remove("bg-gray-300", "dark:bg-gray-600")
      this.trackTarget.classList.add("bg-primary-600")
      this.knobTarget.style.transform = `translateX(${translateX}px)`
    } else {
      // Animate to inactive state
      this.trackTarget.classList.remove("bg-primary-600")
      this.trackTarget.classList.add("bg-gray-300", "dark:bg-gray-600")
      this.knobTarget.style.transform = "translateX(0)"
    }
  }
}
